import {Component, EventEmitter, Inject, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {CommmCode} from 'src/app/utils/constante/CommonCode';
import {LoginService} from 'src/app/modules/services/user/login/login.service';
import {Platform} from '@angular/cdk/platform';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ConfirmDialogService} from 'src/app/modules/services/ui/confirm-dialog.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CertifFournisseurService} from 'src/app/modules/services/fournisseur/certif-four/certif-fournisseur.service';
import {CertifAchetService} from 'src/app/modules/services/acheteur/certif/certif-achet.service';
import {ToastService} from 'src/app/modules/toast/toast.service';
import {Certificat, InfoOs} from 'src/app/domain';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import {CertificatDetailsComponent} from 'src/app/pages/auth/certificat-details/certificat-details.component';
import {DateFormatTimePipe} from 'src/app/modules/pipes/pipes/date-formatwithtime.pipe';
import {DateFormatPipe} from 'src/app/modules/pipes/pipes/date-format.pipe';
import {AppTranslateService} from '../../../../../modules/services/translate/app-translate.service';


type Column = keyof Certificat | 'action';

@Component({
    selector: 'app-dialog-renouveler-certif',
    templateUrl: './dialog-renouveler-certif.component.html',
    styleUrls: ['./dialog-renouveler-certif.component.css']
})
export class DialogRenouvelerCertifComponent implements OnInit {


    disabled_conn: boolean = true;

    form = this.formBuilder.group({

            encData: this.formBuilder.control(null, [Validators.required]),

            indRegNo: this.formBuilder.control(null, [Validators.required]),


        },
    );

    @Output() next = new EventEmitter<any>();
    data: any[];
    @Input() id;

    inputData: any;


    acheteur;
    CommmCode = CommmCode;

    validCin = null;
    bizRegNo;
    disabled = false;
    DOWNLOAD_URL_BASE = 'https://www.tuneps.tn/localserver/';
    @Input() certificatees: Certificat[];
    dataSource = new MatTableDataSource<Certificat>();
    displayedColumns: Column[] = [
        'commonName',
        'issuerCommonName',
        'notAfter',
        'action',
    ];
    labels: Partial<Record<Column, string>> = {
        commonName: 'Utilisateur',
        issuerCommonName: 'Emetteur',
        notAfter: 'Date d\'expiration',
    };
    selection = new SelectionModel<Certificat>(false, []);
    @Input() ondelete: boolean;
    certificatdetails: Certificat[] = [];
    certificates: Certificat[] = [];
    infooscert: InfoOs;
    name: string;
    securevalue: string = '';
    encdatavalue: string = '';
    certiflocalbool: boolean = false;
    isAuthenticating = false;

    constructor(private formBuilder: FormBuilder,
                private loginService: LoginService,
                public platform: Platform,
                private dialog: MatDialog,
                private router: Router,
                private confirmdialog: ConfirmDialogService,
                private activatedRoute: ActivatedRoute,
                private certifAchetService: CertifAchetService,
                private certifFournisseurService: CertifFournisseurService,
                private toast: ToastService,
                private appTranslateService: AppTranslateService,
                private dateFormatTimePipe: DateFormatTimePipe,
                @Inject(MAT_DIALOG_DATA) data,
                private dateFormatPipe: DateFormatPipe,
                private dialogg: MatDialogRef<DialogRenouvelerCertifComponent, { data: any }>,) {
        this.acheteur = data.acheteur;
        this.inputData = data;

    }

    get currentDate() {
        return new Date();
    }

    get readColumns() {
        return this.displayedColumns.filter((column) => column !== 'action');
    }

    ngOnInit(): void {


        this.getAll();
        this.verifierLocal();

     //   this.checkCinIsMandataire();


    }

    checkCinIsMandataire() {
        let indRegNoControl = this.form.get('indRegNo');


        indRegNoControl.valueChanges.subscribe((indRegNo) => {
            if (!!indRegNo) {

                // check is mandataire pour fournisseur
                // check cin in UmCert pour acheteur
                const reqParams = {
                    bizRegNo: this.acheteur ? this.inputData?.userId : this.inputData?.bizRegNo,
                    cin: indRegNo,
                    isAcheteur: this.acheteur
                };
                this.certifFournisseurService.checkCin('checkCinRenouvCert', 'portail', 'GET', reqParams).subscribe({
                    next: (response) => {

                        if (response['code'] == '200') {
                            if (response['payload'] == 'N') {
                                if (this.acheteur) {
                                    indRegNoControl.setErrors({notValidCinAcheteur: response['paylaod'] == 'N' ? true : null});
                                } else {
                                    indRegNoControl.setErrors({notValidCinMandataire: response['paylaod'] == 'N' ? true : null});
                                }
                            } else {
                                if (indRegNoControl.hasError('notValidCinMandataire')) {
                                    delete indRegNoControl.errors['notValidCinMandataire'];
                                    indRegNoControl.updateValueAndValidity();
                                }
                                if (indRegNoControl.hasError('notValidCinAcheteur')) {
                                    delete indRegNoControl.errors['notValidCinAcheteur'];
                                    indRegNoControl.updateValueAndValidity();
                                }
                            }
                        } else {
                            console.error('Error in DialogRenouvelerCertifComponent/checkCinIsMandataire, code erreur::', response['code']);
                        }
                    },
                    error: (e) => {
                        console.error('Error in DialogRenouvelerCertifComponent/checkCinIsMandataire, erreur:: ', e);
                    }
                });


            } else {
                if (indRegNoControl.hasError('notValidCinMandataire')) {
                    delete indRegNoControl.errors['notValidCinMandataire'];
                    indRegNoControl.updateValueAndValidity();
                }
            }

        });


    }

    onSuccess() {

        this.selection.selected.forEach((row) => {
            this.name = row.commonName;
        });
        this.isAuthenticating = true;
        this.loginService.getEncData(this.name).subscribe((encData) => {
            this.form.controls['encData'].setValue(encData);
            if (this.form.valid) {
                const data = Object.assign(this.form.getRawValue(), {'bizRegNo':this.inputData?.bizRegNo, 'userId':this.inputData?.userId})
                
                this.dialogg.close({
                    data: data,
                });
            }

        });

    }

    get(key: string) {
        return this.form.get(key) as FormControl;
    }

    getdetail() {

    }

    ngAfterViewInit(): void {


    }

    setNewDateValue(dateValue: any, control: FormControl) {
        control.setValue('new darte value', dateValue);
        // control.setValue('control', control);
        control.setValue(dateValue);
    }

    getAll() {
        this.loginService.getCer().subscribe((res) => {
            this.certificates = res;
            this.dataSource.data = res;

            let tData = [...this.certificates];
            for (const item of tData) {
                item['notAfter'] = this.dateFormatPipe.transform(new Date(item.notAfter));
                item['notBefore'] = this.dateFormatPipe.transform(new Date(item.notBefore));

            }
            this.certificates = [...tData];



        });


    }

    verifierLocal() {
        this.loginService.getInfoCer().subscribe((res) => {
            this.infooscert = res;
            if ((this.infooscert.name = 'TUNEPS Local Server')) {
                this.certiflocalbool = true;
            }
        });
    }

    verifOS() {
        var OSName = 'Windows';
        if (navigator.appVersion.indexOf('Mac') != -1) {
            OSName = 'MacOS';
        }
        if (navigator.appVersion.indexOf('X11') != -1) {
            OSName = 'UNIX';
        }
        if (navigator.appVersion.indexOf('Linux') != -1) {
            OSName = 'Linux';
        }

        // this.loginService.getInfoCer().subscribe(res=>{

        //   this.infooscert=res    ;

        // console.log("os ::::" + this.infooscert.os)
        if (OSName == 'Windows') {
            window.location.href = this.DOWNLOAD_URL_BASE + 'TUNEPS.exe';
        } else if ((OSName = 'Linux')) {
            window.location.href = this.DOWNLOAD_URL_BASE + 'TUNEPS-linux.sh';
        } else if (OSName == 'Mac_Os') {
            window.location.href = this.DOWNLOAD_URL_BASE + 'TUNEPS.pkg';
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        const {certificatees} = changes;
        if (certificatees.currentValue !== certificatees.previousValue) {
            this.loadDataSource(certificatees.currentValue);
        }
    }

    loadDataSource(certificates: Certificat[]) {
        this.dataSource.data = certificates;
    }

    openCertif(certificat) {
        this.certificatdetails.push(certificat);

        const dialogRef = this.dialog.open(CertificatDetailsComponent, {
            data: {certificatdetails: this.certificatdetails},
            disableClose: true,
            direction: this.appTranslateService.getDir(),
            width: '70vw',
        });
        dialogRef.afterClosed().subscribe((submit) => {
            this.certificatdetails = [];
            if (this.selection.isSelected) {
                this.disabled_conn = false;
            } else {
                this.disabled_conn = true;
            }
        });
    }

    toggle() {
        this.disabled_conn = false;
    }

}
